module.exports = __webpack_public_path__ + "img/more_button_gray.16a744d9.png";